import { render, staticRenderFns } from "./IconYxwk.vue?vue&type=template&id=22a369b8"
import script from "./IconYxwk.vue?vue&type=script&lang=js"
export * from "./IconYxwk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports